import { LocationState } from 'src/actuators/LocationState.ts';

export type LocationStateContextType = {
    locationState: LocationState;
    setLocationState: (state: LocationState) => void;
}

export const initLocationState: LocationState = {
    actuatorLabel: '',
    actuatorPage: '1',
    selectedAccessories: [],
    qty: 1,
    sent: false,
    checkoutComment: '',
};

export const isLocationState = (arg: unknown): arg is LocationState => typeof arg === 'object' &&
    arg !== null && 'selectedAccessories' in arg && arg.selectedAccessories !== undefined;
